import { LanguageEnum } from "enums/LanguageEnum";
import { NavigationModel } from "models/NavigationModel";
import { TranslationsContextProps, useTranslations } from "providers";
import { useMemo } from "react";

import { HeaderDropdownItem } from "./HeaderDropdownItem";
import { HeaderMenuDropdown } from "./HeaderMenuDropdown";

interface LanguageMenuProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

const getLanguageLabel = (i18n: TranslationsContextProps, language: LanguageEnum) => {
  switch (language) {
    case LanguageEnum.FR:
      return i18n.Header_French;
    case LanguageEnum.IT:
      return i18n.Header_Italian;
    case LanguageEnum.EN:
      return i18n.Header_English;
    default:
      return i18n.Header_German;
  }
};

function addLanguage(i18n: TranslationsContextProps, items: NavigationModel[], lang: LanguageEnum) {
  items.push({
    onClick: () => {
      i18n.changeLanguage(lang);
    },
    text: getLanguageLabel(i18n, lang),
    isSelected: i18n.currentLanguage == lang,
  });
}

export const LanguageMenu: React.FC<LanguageMenuProps> = ({ isOpen, setIsOpen }) => {
  const i18n = useTranslations();

  const id = "language-menu";

  const items = useMemo(() => {
    const items: NavigationModel[] = [];
    addLanguage(i18n, items, LanguageEnum.DE);
    addLanguage(i18n, items, LanguageEnum.FR);
    addLanguage(i18n, items, LanguageEnum.IT);
    addLanguage(i18n, items, LanguageEnum.EN);
    return items;
  }, [i18n]);

  const trigger = (
    <>
      <div className="sbb-header-nav-item-icon me-1">
        <i className="ms-Icon ms-Icon--Globe" />
      </div>
      <div className="sbb-header-nav-item-text">{getLanguageLabel(i18n, i18n.currentLanguage)}</div>
      <div className="sbb-header-nav-item-icon ms-2">
        <i className="ms-Icon ms-Icon--ChevronDown" />
      </div>
    </>
  );

  return (
    <HeaderMenuDropdown isOpen={isOpen} setIsOpen={setIsOpen} trigger={trigger} id={id}>
      {items.map((item, i) => (
        <HeaderDropdownItem key={`language  enu-${i}`} item={item} />
      ))}
    </HeaderMenuDropdown>
  );
};
